export default __webpack_public_path__ + "static/media/cryptozanex done.b9057752.png";